import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Global from '../../../../store/global-selectors';
import { ActionableFilterPill } from '../../index';
import getDisplayInformation from '../../../data-driven-logo/get-display-information';

const getDisplayName = (appliedFilters) => {
  if (appliedFilters.length === 0) {
    return <FormattedMessage defaultMessage='Carrier' description='filterOptions.carrier' id='ZkWy+1' />;
  }
  if (appliedFilters.length > 1) {
    return <FormattedMessage defaultMessage='(Multiple Carriers)' description='filterOptions.multipleCarriers' id='5jq8GC' />;
  }
  const [filter] = appliedFilters;
  const displayInformation = getDisplayInformation({
    carrierId: filter.criterionArgumentValue,
  });
  if (!displayInformation) {
    return <FormattedMessage defaultMessage='Carrier' description='filterOptions.carrier' id='ZkWy+1' />;
  }
  return displayInformation.name;
};

const mapStateToProps = (state, ownProps) => {
  const appliedFilters = Global.selectShipmentsFilteringActiveFilterViewFiltersById(state, {
    filterById: ownProps.filterById,
  });

  return {
    isSelected: !!appliedFilters.length,
    displayContent: getDisplayName(appliedFilters),
  };
};

export const Carrier = connect(mapStateToProps, null, null, { forwardRef: true })(ActionableFilterPill);
